import { api } from '@/api';
import { ok } from 'neverthrow';

export const getGoogleAuthConnectURLMutation = () => {
  return {
    mutationFn: async (params: Parameters<typeof api.GoogleAuthConnect>[0]) => {
      const response = await api.GoogleAuthConnect(params);

      return ok(response.data);
    },
  };
};
